import { LinkedEntity } from '@blk/aw-bff-typescript-models';
import { AxiosResponse } from 'axios';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { awPortfolioApi } from './Base';

export async function getLinkedEntitiesForPortfolio({
  aggIDTag,
  aggIDValue,
}: {
  aggIDTag: string;
  aggIDValue: string;
}): Promise<AxiosResponse<LinkedEntity[]>> {
  const path = `portfolios/${aggIDTag}/${aggIDValue}/linked-entities`;
  const response = await awPortfolioApi.get<AGraphWrappedType<LinkedEntity[], 'linkedEntities'>>(path, {});
  return unwrapAGraphResponse(response, 'linkedEntities');
}

// TODO deprecate me?
export function createLinkedEntitiyForPortfolio({
  aggIDTag,
  aggIDValue,
  asOf,
  overrideMetadata,
}: {
  aggIDTag: string;
  aggIDValue: string;
  asOf: string;
  overrideMetadata: { [index: string]: unknown };
}): Promise<AxiosResponse<LinkedEntity>> {
  const path = 'linked-entities';
  return awPortfolioApi.post(path, {
    entity: {
      asOf,
      id: aggIDValue,
      tag: aggIDTag,
      origin: 'SYSTEM',
    },
    tag: 'endClient',
    overrideMetadata,
  });
}
